import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
    IApiResponse,
    IPaginatedApiResponse,
} from "../../../utils/types/api-response";
import { IPayment, IPaymentsFilters } from "../types/payments.types";
import { getPayments } from "../services/payments.services";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";

export function useGetPayments(filters: IPaymentsFilters) {
    return useQuery<
        IPaginatedApiResponse<IPayment[]>,
        AxiosError<IApiResponse<IPayment[]>>
    >({
        queryKey: ["payments", handleRemoveEmptyParamFromQueryParams(filters)],
        queryFn: () => getPayments(filters),
    });
}
